<template>
  <div class="flex-col card">
    <div
      v-if="0"
      class="message"
    >
      <span
        class="check-total"
        @click="checkMuscleTotal"
        >{{ $t('H8003') }}</span
      >
    </div>
    <div class="elastic-flex-item card-content">
      <!-- 正面 -->
      <div class="muscle-item">
        <img
          v-if="state.front"
          :src="state.front"
        />
        <span
          v-for="item in frontLineText"
          :key="'front' + item.muscleId"
          :style="item.frontLineTextPosition"
          class="line-text"
          >{{ $t('H8004', { OvO: item.sets }) }}</span
        >
      </div>

      <!-- 反面 -->
      <div class="muscle-item">
        <img
          v-if="state.rear"
          :src="state.rear"
        />
        <span
          v-for="item in rearLineText"
          :key="'rear' + item.muscleId"
          :style="item.rearLineTextPosition"
          class="line-text"
          >{{ $t('H8004', { OvO: item.sets }) }}</span
        >
      </div>
    </div>
    <!-- <fill-dialog ref="fill-dialog"></fill-dialog> -->
  </div>
</template>

<script setup>
import { activityDetailStore } from '@client/store/activityDetailStore';
import { computed, nextTick, onBeforeMount, onBeforeUnmount, reactive } from 'vue';
// import FillDialog from './fill-dialog.vue';

import { mixPic, findMuscleColor } from './utils';
import { musclePic } from './const';

const consts = {
  muscleUniqueKey: 'muscleId',
  muscleLevelKey: 'level',
  sizeType: 'fill'
};

const activityDetailStoreRef = activityDetailStore();
const muscleData = computed(() => activityDetailStoreRef.activityDetail?.muscleList || []);

const muscleList = computed(() => {
  const sizeType = consts.sizeType;
  const uniqueKey = consts.muscleUniqueKey;
  const levelKey = consts.muscleLevelKey;
  const result = muscleData.value;
  const frontPic = musclePic.front;
  const rearPic = musclePic.rear;

  result.unshift({
    duration: 0,
    [levelKey]: 0,
    [uniqueKey]: 0,
    muscleKey: '',
    reps: 0,
    sets: 0
  });

  result.forEach((item) => {
    item = Object.assign(item, frontPic[item[uniqueKey]] || {});

    const musclePath = `/muscle/${sizeType}/${gender.value}`;
    // 正面
    item.frontPic =
      frontPic[item[uniqueKey]] && frontPic[item[uniqueKey]].image ? `${musclePath}/front/${frontPic[item[uniqueKey]].image}` : '';
    item.frontLinePic =
      frontPic[item[uniqueKey]] && frontPic[item[uniqueKey]].lineImage ? `${musclePath}/front/${frontPic[item[uniqueKey]].lineImage}` : '';
    item.frontLineTextPosition = (frontPic[item[uniqueKey]] && frontPic[item[uniqueKey]].position) || null;

    // 背面
    item.rearPic = rearPic[item[uniqueKey]] && rearPic[item[uniqueKey]].image ? `${musclePath}/rear/${rearPic[item[uniqueKey]].image}` : '';
    item.rearLinePic =
      rearPic[item[uniqueKey]] && rearPic[item[uniqueKey]].lineImage ? `${musclePath}/rear/${rearPic[item[uniqueKey]].lineImage}` : '';
    item.rearLineTextPosition = (rearPic[item[uniqueKey]] && rearPic[item[uniqueKey]].position) || null;

    item.levelColorInfo = findMuscleColor(item[levelKey]);
  });
  return result;
});

const frontLineText = computed(() => {
  return muscleList.value.filter((item) => {
    return item.frontLinePic && item.frontLineTextPosition;
  });
});
const rearLineText = computed(() => {
  return muscleList.value.filter((item) => {
    return item.rearLinePic && item.rearLineTextPosition;
  });
});

const gender = computed(() => (activityDetailStoreRef.activityDetail?.userInfo?.sex === 0 ? 'male' : 'female'));

const state = reactive({
  sizeType: 'fill',
  front: '',
  rear: ''
});

nextTick(() => {
  // 生成正面图
  mixPic(muscleList.value, 'front')
    .then((base64) => {
      state.front = base64;
    })
    .catch((err) => {
      console.error(err);
      state.front = muscleList.value[0] && muscleList.value[0].frontPic;
    });

  // 生成背面图
  mixPic(muscleList.value, 'rear')
    .then((base64) => {
      state.rear = base64;
    })
    .catch((err) => {
      console.error(err);
      state.rear = muscleList.value[0] && muscleList.value[0].rearPic;
    });
});

function checkMuscleTotal() {
  // refs['fill-dialog'].open();
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  .message {
    padding: 8px 16px;
    text-align: right;

    .check-total {
      font-size: 14px;
      color: #00b3ff;
      cursor: pointer;
    }
  }

  .card-content {
    padding: 10px 0 30px 0;
    box-sizing: border-box;
    overflow: hidden;

    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-around;

    .muscle-item {
      flex-basis: 50%;
      flex-grow: 0;
      flex-shrink: 0;

      position: relative;
      line-height: 0;
      font-size: 0;

      img {
        width: 100%;
        object-fit: contain;
      }

      .line-text {
        position: absolute;
        line-height: 1;
        font-size: 12px;
        color: #ffffff;
        white-space: nowrap;
      }
    }
  }
}
</style>
